import styled, { css } from 'styled-components';
import { colors } from '@bitcoin-portal/bitcoincom-pkg-theme';
import media from './media';
export const LogoWrapper = styled.div `
  padding-bottom: 25px;

  /* TODO: serve diff size image files? */
  img {
    height: 22px !important;
    width: 150px !important;

    ${media.lg `
      height: 26px !important;
      width: 176px !important;
    `}
  }
`;
export const FooterWrapper = styled.footer `
  ${({ theme, contrast }) => css `
    background-color: ${contrast ? colors.solid.vulcan : colors.solid.bgGrey};
    color: ${theme.palette.text.default};
    width: 100%;
    padding: ${theme.spacing.unit * 12}px 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
    padding-bottom: ${theme.spacing.unit * 8}px;
    overflow: hidden;
    -webkit-font-smoothing: antialiased;

    ${media.md `
      font-size: 16px;
    `}

    ${media.xl `
      padding-bottom: ${theme.spacing.unit * 35}px;
    `}
  `}
`;
export const FooterTitle = styled.div `
  ${({ theme }) => css `
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: ${theme.spacing.unit}px;

    ${media.md `
      font-size: 16px;
    `}

    ${media.lg `
      margin-bottom: 12px;
    `}
  `}
`;
export const FooterLink = styled.a `
  ${({ theme }) => css `
    opacity: 0.59;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 24px;
    text-decoration: none;

    & > :hover {
      color: ${theme.palette.text.default};
    }

    ${media.md `
    font-size: 16px;
    line-height: 27px;
    font-weight: 400;
  `}
  `}
`;
export const FooterParagraph = styled.p `
  ${() => css `
    color: #2d323b; //TODO: change in theme
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 24px;
    margin: 24px 0;

    ${media.md `
      font-size: 16px;
      font-weight: 400;
    `}
  `}
`;
export const FooterContent = styled.div `
  ${({ contrast }) => css `
    display: grid;
    background-color: ${contrast ? colors.solid.vulcan : colors.solid.bgGrey};
    align-items: flex-start;
    position: relative;
    width: 100%;
    max-width: 1440px;
    margin: auto;
    padding: 0 30px;
    box-sizing: border-box;
    column-gap: 10px;
    grid-template-areas:
      'header header'
      'company products'
      'company data'
      'educate follow'
      'get follow'
      'spend follow';

    ${FooterTitle} {
      color: ${contrast ? colors.solid.white : colors.solid.textOne};
    }

    ${FooterLink}, ${FooterParagraph} {
      color: ${contrast ? '#b0b7c3' : colors.solid.textTwo};
    }

    ${media.md `
      padding: 0 47px;
      grid-template-areas:
        'header company products '
        'header company data'
        '. company data'
        '. educate follow'
        '. get follow'
        '. spend follow';
    `}

    ${media.xl `
      padding: 0 100px;
      grid-template-columns: repeat(6, 1fr);
      grid-template-areas:
        'header header company educate products follow'
        'header header company get data follow'
        'header header company spend data follow';
    `}
  `}
`;
export const FooterSection = styled.div `
  ${({ area, theme }) => css `
    grid-area: ${area};
    display: flex;
    flex-direction: column;
    padding: 0 ${theme.spacing.unit}px;
  `}
`;
export const FooterList = styled.div `
  ${({ theme }) => css `
    overflow: hidden;
    height: auto;
    max-height: unset;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 0;
    padding: 0;
    margin-bottom: ${theme.spacing.unit * 4}px;
    text-align: left;
  `}
`;
export const SelectContainer = styled.div `
  & > div {
    height: 48px;
  }

  .mlt-select__indicators {
    height: 48px !important;
  }

  ${media.md `
    margin-bottom: 0;

    & > div {
      height: 32px;
      width: 152px;
    }

    .mlt-select__indicators {
      height: 32px !important;
    }
  `}

  ${media.lg `
    & > div {
      width: 180px;
    }
  `}
`;
export const Apps = styled.div `
  display: none;

  ${media.xl `
    display: flex;
    justify-content: center;
    flex-wrap: unset;
    flex-flow: column nowrap;
  `}

  & > a {
    max-width: 180px;
    margin: 0;
  }

  & > a:first-child {
    padding-bottom: 16px;
  }

  & > a > div {
    max-width: 180px;
    max-height: 48px;
  }

  & > a > div > img {
    height: auto;
  }
`;
//# sourceMappingURL=styled.js.map